import { register, getPrefix } from '../../../Utils'
import mapStyles from './MapStyles'
import 'default-passive-events'

const LocationFinder = el => {
  let map
  let google = window.google
  let MarkerClusterer = window.MarkerClusterer

  const prefix = getPrefix(el)
  const locations = JSON.parse(el.dataset.locations)
  const labels = JSON.parse(el.dataset.labels)
  const categories = JSON.parse(el.dataset.filters)
  const mapMessageContainer = el.querySelector(`.${prefix}map-message`)
  const mapMessageContent = el.querySelector(`.${prefix}map-message-content`)
  const mapMessageCloser = el.querySelector(`.${prefix}map-message-close`)
  const searchInput = el.querySelector(`.${prefix}search-input`)
  const searchTrigger = el.querySelector(`.${prefix}search-icon`)
  const filterContainer = el.querySelector(`.${prefix}filter-container`)
  const filterToggler = el.querySelector(`.${prefix}filter-toggler`)
  const filters = el.querySelector(`.${prefix}filters`)
  const listToggler = el.querySelector(`.${prefix}list-toggler`)
  const listContainer = el.querySelector(`.${prefix}list-container`)
  const resultCountContainer = el.querySelector(`.${prefix}list-count`)
  const filterInfoContainer = el.querySelector(`.${prefix}filter-info`)
  const filterIconEmpty = el.querySelector(`.${prefix}filter-icon-empty`)
  const filterIconFilled = el.querySelector(`.${prefix}filter-icon-filled`)
  const markerImagePath = el.dataset.markerImage
  const allMarkers = []
  const allTooltips = []
  let listMarkers = []
  let servicedCountries = {}
  let markerCluster
  let activeTooltip
  let currentFilterId
  let currentFilter

  const initFilters = () => {
    const filterContainer = el.querySelector(`.${prefix}filters`)
    const filters = filterContainer.querySelectorAll(`.${prefix}filter`)
    const filterResetButton = filterContainer.querySelector(`.${prefix}filter-reset-button`)

    const resetFilters = e => { // das hier und forEach aus Z.42 kann in eine universelle funktion
      e.preventDefault()

      filters.forEach(filter => {
        filter.classList.remove(`${prefix}active`)
        currentFilterId = 0
        currentFilter = null
        filterItems()
      })

      if (searchInput) {
        searchInput.value = ''
      }

      toggleFilterView(false)
    }

    const clickFilter = (e) => {
      e.preventDefault()

      currentFilterId = +e.currentTarget.dataset.filterId === currentFilterId ? 0 : +e.currentTarget.dataset.filterId

      filters.forEach(filter => {
        filter.classList.toggle(`${prefix}active`, e.currentTarget === filter && e.currentTarget !== currentFilter)
      })

      currentFilter = currentFilter === e.currentTarget ? null : e.currentTarget

      filterItems()

      toggleFilterView(currentFilter !== e.currentTarget)
    }

    filters.forEach(filter => {
      filter.addEventListener('click', clickFilter)
    })

    filterResetButton.addEventListener('click', resetFilters)
  }

  const toggleListView = (openList = true) => {
    listContainer.classList.toggle(`${prefix}is--active`, openList)
    listToggler.classList.toggle(`${prefix}is--active`, openList)
  }

  listToggler.addEventListener('click', e => { e.preventDefault(); toggleListView(!listContainer.classList.contains(`${prefix}is--active`)) })

  const showListViewOnce = () => {
    toggleFilterView()
    toggleListView()
    filterContainer.removeEventListener('mouseover', showListViewOnce)
  }

  filterContainer.addEventListener('mouseover', showListViewOnce)

  const toggleFilterView = (openFilter = true) => {
    filters.classList.toggle(`${prefix}is--active`, openFilter)
    filterToggler.classList.toggle(`${prefix}is--active`, openFilter)
  }

  filterToggler.addEventListener('click', e => { e.preventDefault(); toggleFilterView(!filters.classList.contains(`${prefix}is--active`)) })

  const toggleFilterIcon = (isFilled = true) => {
    filterIconEmpty.classList.toggle('d-none', isFilled)
    filterIconFilled.classList.toggle('d-none', !isFilled)
  }

  const changeMarkerVisibilityByFilter = () => {
    allMarkers.forEach(marker => marker.setVisible(marker.visibleByFilter))
    markerCluster.repaint()
    renderList()
  }

  const showMapMessage = (message, duration) => {
    mapMessageContent.innerHTML = message
    mapMessageContainer.classList.add(`${prefix}is--visible`)
    if (duration) {
      window.setTimeout(() => {
        mapMessageContainer.classList.remove(`${prefix}is--visible`)
      }, duration)
    }
  }

  const closeMapMessage = () => {
    mapMessageContainer.classList.remove(`${prefix}is--visible`)
  }

  mapMessageCloser.addEventListener('click', closeMapMessage)

  const filterItems = () => {
    allMarkers.forEach(marker => {
      if (currentFilterId) {
        // marker.setVisible(marker.businessAreas && marker.businessAreas.includes(currentFilterId))
        marker.visibleByFilter = marker.businessAreas && marker.businessAreas.includes(currentFilterId)
        filterInfoContainer.textContent = `(${labels.withFilter} ${currentFilter.textContent})`
        toggleFilterIcon()
      } else {
        // marker.setVisible(true)
        marker.visibleByFilter = true
        filterInfoContainer.textContent = ''
        toggleFilterIcon(false)
      }
    })
    changeMarkerVisibilityByFilter()
  }

  const setBoundsToMarkers = () => { // currently not used, outsource as well. rauszoome wenn liste auf 0 bei filter!
    const mapBounds = new google.maps.LatLngBounds()

    allMarkers.forEach(marker => {
      if (marker.getVisible()) { // old way?
        mapBounds.extend(marker.getPosition())
      }
    })
    map.fitBounds(mapBounds, 0)
  }

  const changeActiveTooltip = (tooltip, marker) => {
    if (activeTooltip) {
      activeTooltip.close()
    }
    tooltip.open({
      anchor: marker,
      map,
      shouldFocus: false
    })
    activeTooltip = tooltip
  }

  const initMap = () => {
    const mapContainer = el.querySelector(`.${prefix}map-container`)

    map = new google.maps.Map(mapContainer, {
      center: new google.maps.LatLng(30, 0), // change later
      zoom: 2,
      maxZoom: 16,
      styles: mapStyles,
      fullscreenControl: false,
      mapTypeControlOptions: {
        position: google.maps.ControlPosition.TOP_RIGHT
      }
    })

    const markerIcon = {
      url: markerImagePath,
      scaledSize: new google.maps.Size(25, 25),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(0, 0)
    }

    if (locations && typeof locations === 'object') {
      /* Initially create all markers from the locations array */
      locations.forEach(location => {
        const tooltip = new google.maps.InfoWindow({
          id: location.id,
          content: `<div>${location.title ? `${location.title}<br>` : ''}${location.street ? `${location.street} ${location.streetNumber ? `${location.streetNumber}` : ''}<br>` : ''}${location.zip || location.city ? `${location.zip} ${location.city}<br>` : ''}${location.country ? `${location.country}<br>` : ''}<br>${location.phone ? `<a href="tel:${location.phone}">${location.phone}</a><br>` : ''}${location.fax ? `${location.fax}<br>` : ''}<br>${location.email ? `<a href="mailto:${location.email}">${location.email}</a><br>` : ''}${location.website ? `<a href="${location.website}" target="_blank">${location.website}</a>` : ''}</div>`
        })
        allTooltips.push(tooltip) // alternative could be a global function that re-fills and re-positions generic tooltip on open
        const mapMarker = new google.maps.Marker({
          id: location.id,
          position: { lat: +location.latitude, lng: +location.longitude },
          map: map,
          title: location.title,
          city: location.city,
          country: location.country,
          icon: markerIcon,
          businessAreas: location.businessAreas,
          countryCode: location.countryIsoCode,
          visibleByFilter: true
        })
        mapMarker.addListener('click', () => {
          changeActiveTooltip(tooltip, mapMarker)
        })
        google.maps.event.addListener(map, 'click', () => {
          tooltip.close()
        })
        allMarkers.push(mapMarker)
        /* create object with all countries that have a substitute location */
        if (location.servicedCountries.length > 0) {
          location.servicedCountries.forEach(serviceCountry => {
            if (!servicedCountries.hasOwnProperty(serviceCountry)) {
              servicedCountries = { ...servicedCountries, [serviceCountry]: location.id }
            }
          })
        }
      })
      markerCluster = new MarkerClusterer(map, allMarkers, { imagePath: markerImagePath, ignoreHidden: true })
    }

    const mapBoundsChanged = e => { // ggf. eher in eine initList() o.Ä.
      renderList()
      if (activeTooltip) {
      }
    }

    map.addListener('idle', mapBoundsChanged)
  }

  const clickListItem = (e, marker) => {
    map.setZoom(12) // this needs a smoother solution
    map.panTo(marker.getPosition())
    const currentTooltip = allTooltips.find(tooltip => tooltip.id === marker.id)
    changeActiveTooltip(currentTooltip, marker)
  }

  const getBusinessAreaTitle = id => {
    return categories.find(businessArea => businessArea.id === id).title
  }

  const renderList = () => {
    const bounds = map.getBounds()
    listMarkers = allMarkers.filter(marker => bounds.contains(marker.getPosition()) && marker.getVisible()) // evtl. in eigene function
    listContainer.textContent = ''
    resultCountContainer.textContent = `${listMarkers.length} ${listMarkers.length === 1 ? labels.resultsSingular : labels.resultsPlural}`
    listMarkers.forEach(marker => {
      // outsource to own list-item (class or) building func in another file
      const listItem = document.createElement('div')
      const businessAreasString = marker.businessAreas.map(businessArea => getBusinessAreaTitle(businessArea)).join(', ')
      listItem.innerHTML = `<h4>${marker.title}</h4><span>${marker.city}, ${marker.country}</span><strong>${businessAreasString}</strong>` // innerHTML bad performance?
      listItem.addEventListener('click', e => clickListItem(e, marker))
      listContainer.appendChild(listItem)
    })
  }

  const fitBoundsByCountryCode = (countryCode) => { // kann das hier sparen und die bounds aus dem "place" nehmen?
    const geocoder = new google.maps.Geocoder()

    geocoder.geocode({
      componentRestrictions: {
        country: countryCode
      }
    }, (results, status) => {
      if (status === 'OK') {
        map.fitBounds(results[0].geometry.viewport, 0)
      } else {
        console.error('Geocode was not successful for the following reason: ' + status)
      }
    })
  }

  const initSearchFilter = () => {
    const searchOptions = {
      fields: ['types', 'address_components', 'geometry', 'name'],
      strictBounds: false,
      types: ['geocode']
    }

    const locationSearch = new google.maps.places.Autocomplete(searchInput, searchOptions)

    const changeLocationSearch = e => {
      const place = locationSearch.getPlace()

      if (!place || !place.address_components) {
        return
      }

      // get country codes from only visible markers and remove duplicates
      const availableCountryCodes = [...new Set(allMarkers.reduce((result, marker) => {
        if (marker.getVisible()) {
          result.push(marker.countryCode)
        }
        return result
      }, []))]

      // hier ggf. noch Fehler abfangen, falls wirklich kein Land gibt o.Ä.
      const selectedCountryCode = place.address_components.find(addressComponent => addressComponent.types.includes('country')).short_name

      if (availableCountryCodes.includes(selectedCountryCode)) {
        if (place.types.includes('country')) {
          map.fitBounds(place.geometry.viewport, 0)
          // BESSERE ALTERNATIVE: ausßerhalb des landes auf halbtransparent setzen(?)
          allMarkers.forEach(marker => {
            marker.setVisible(marker.countryCode === selectedCountryCode && marker.visibleByFilter)
          })
          // HIER könnte alternativ auch nicht neu geladen werden, sondern das suchfeld einen "leeren" button o.Ä. erhalten
          // dann ggf. filter nimmt gesuchten begriff mit auf falls karte nicht bewegt wird
          google.maps.event.addListenerOnce(map, 'idle', () => {
            markerCluster.repaint()
            google.maps.event.addListenerOnce(map, 'idle', () => {
              filterItems()
            })
          })
        } else {
          map.panTo(place.geometry.location)
          const zoom = map.getZoom() // helper function, redundant +1
          map.setZoom(zoom < 10 ? 10 : zoom) // zu tief für z.B. "Hamburg"

          const recursiveMarkerFinder = () => {
            google.maps.event.addListenerOnce(map, 'idle', () => {
              if (listMarkers.length < 1) {
                map.setZoom(map.getZoom() - 1)
                recursiveMarkerFinder()
              }
            })
          }

          recursiveMarkerFinder()
        }
      } else if (servicedCountries.hasOwnProperty(selectedCountryCode)) {
        // redundant start
        const substituteMarker = allMarkers.find(marker => marker.id === servicedCountries[selectedCountryCode])
        map.setZoom(12) // this needs a smoother solution
        map.panTo(substituteMarker.getPosition())
        const substituteTooltip = allTooltips.find(tooltip => tooltip.id === substituteMarker.id)
        changeActiveTooltip(substituteTooltip, substituteMarker)
        // redundant end
        showMapMessage(labels.substituteLocationFound)
      } else { // backup Schweiz
        fitBoundsByCountryCode('CH') // durch place CH ersetzen
        // hier HQ popup öffnen?
        showMapMessage(labels.noLocationInCountry)
      }
    }

    locationSearch.addListener('place_changed', changeLocationSearch)

    const chooseFirstFromResults = e => {
      const step1 = new Event('keydown')
      step1.keyCode = 40
      google.maps.event.trigger(searchInput, 'keydown', step1)

      const step2 = new Event('keydown')
      step1.keyCode = 13
      step1.triggered = true
      google.maps.event.trigger(searchInput, 'keydown', step2)

      const focusOutEvent = new Event('blur')

      searchInput.dispatchEvent(focusOutEvent)
    }

    searchInput.addEventListener('keydown', e => {
      if (e.keyCode === 13 && !e.triggered) {
        chooseFirstFromResults()
      }
    })

    searchTrigger.addEventListener('click', chooseFirstFromResults)
  }

  initFilters()
  initMap()
  initSearchFilter()
}

const blockedByConsentView = el => {
  // Mockup Map, needed by usercentrics popup to show up
  let map
  let google = window.google

  const prefix = getPrefix(el)

  const mapContainer = el.querySelector(`.${prefix}map-container`)

  map = new google.maps.Map(mapContainer, {
    center: new google.maps.LatLng(30, 0), // change later
    zoom: 2,
    maxZoom: 16,
    fullscreenControl: false,
    mapTypeControlOptions: {
      position: google.maps.ControlPosition.TOP_RIGHT
    }
  })
}

register('LocationFinder', LocationFinder, 'InitLocationFinder', blockedByConsentView, 'S1pcEj_jZX')
